import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";

export class EntangleHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {
    if (params.sideEffects.length === 0) return;

    if (params.sideEffects.length > 1)
      throw new Error("Multiple entangles in a single move is invalid");

    var entangle = params.sideEffects[0];

    if (entangle.piecesToEffect.length > 1)
      throw new Error("Only one piece can be entangled per move");

    if (entangle.piecesToEffect.length === 0)
      throw new Error("No piece to entangle");

    var pieceToEntangle = entangle.piecesToEffect[0];
    pieceToEntangle.isEntangled = true;
    params.inflictingPiece.entangledPieceId = pieceToEntangle.id;
  }
}

// old code, maybe it's useful?

// import { BoardState, IPiece, Position, PieceType } from "../../types";
// import rhinoDefenseHandler from "./RhinoDefenceHandler";
// import treeHousingHandler from "./TreeHousingHandler";
// import { BaseMovement } from "../BaseMovement";

// class EntangleHandler extends BaseMovement {
//   private entangledPieces: Map<string, IPiece> = new Map();

//   canEntangle(
//     octopus: IPiece,
//     octopusPosition: Position,
//     targetPiece: IPiece,
//     targetPosition: Position,
//     boardState: BoardState
//   ): boolean {
//     if (
//       octopus.type !== PieceType.Octopus ||
//       octopus.isLight === targetPiece.isLight
//     ) {
//       return false;
//     }

//     const dx = targetPosition.col - octopusPosition.col;
//     const dy = targetPosition.row - octopusPosition.row;

//     if (Math.abs(dx) !== 1 || Math.abs(dy) !== 1) {
//       return false;
//     }

//     if (
//       targetPiece.type === PieceType.Rhino &&
//       !rhinoDefenseHandler.canCaptureRhino(
//         octopus,
//         octopusPosition,
//         targetPosition
//       )
//     ) {
//       return false;
//     }

//     return true;
//   }

//   entanglePiece(
//     octopus: IPiece,
//     targetPiece: IPiece,
//     targetPosition: Position,
//     boardState: BoardState
//   ): void {
//     const key = `${targetPosition.col},${targetPosition.row}`;
//     this.entangledPieces.set(key, targetPiece);
//     targetPiece.isEntangled = true;
//     // Update the targetPiece's appearance or any other necessary properties
//   }

//   disentanglePiece(position: Position): void {
//     const key = `${position.col},${position.row}`;
//     const piece = this.entangledPieces.get(key);
//     if (piece) {
//       piece.isEntangled = false;
//       // Revert the piece's appearance or any other necessary properties
//       this.entangledPieces.delete(key);
//     }
//   }

//   isEntangled(position: Position): boolean {
//     const key = `${position.col},${position.row}`;
//     return this.entangledPieces.has(key);
//   }

//   resetEntanglement(): void {
//     for (const [key, piece] of Array.from(this.entangledPieces.entries())) {
//       piece.isEntangled = false;
//       // Revert the piece's appearance or any other necessary properties
//     }
//     this.entangledPieces.clear();
//   }

//   handleOctopusMove(
//     octopus: IPiece,
//     from: Position,
//     to: Position,
//     boardState: BoardState
//   ): void {
//     // Break entanglement when the octopus moves
//     this.resetEntanglement();
//   }

//   handleEntangledPieceCapture(
//     capturedPiece: IPiece,
//     capturedPosition: Position,
//     boardState: BoardState
//   ): void {
//     // Break entanglement when the entangled piece is captured
//     const key = `${capturedPosition.col},${capturedPosition.row}`;
//     if (this.entangledPieces.has(key)) {
//       this.disentanglePiece(capturedPosition);
//     }
//   }

//   handleOctopusCapture(capturedOctopus: IPiece, boardState: BoardState): void {
//     // Break entanglement when the octopus is captured
//     this.resetEntanglement();
//   }

//   handleTreeMove(
//     tree: IPiece,
//     from: Position,
//     to: Position,
//     boardState: BoardState
//   ): void {
//     const octopusInTree = treeHousingHandler.getHousedPiece(from);
//     if (octopusInTree && octopusInTree.type === PieceType.Octopus) {
//       const dx = to.col - from.col;
//       const dy = to.row - from.row;

//       for (const [key, piece] of Array.from(this.entangledPieces.entries())) {
//         const [col, row] = key.split(",").map(Number);
//         const position: Position = { col, row };

//         const newPosition = {
//           col: position.col + dx,
//           row: position.row + dy,
//         };

//         if (this.isValidDragPosition(newPosition, boardState)) {
//           boardState.board[position.col][position.row].Pieces = null;
//           boardState.board[newPosition.col][newPosition.row].Pieces = piece;
//           this.entangledPieces.set(
//             `${newPosition.col},${newPosition.row}`,
//             piece
//           );
//         } else {
//           this.disentanglePiece(position);
//         }
//       }
//     }
//   }

//   private isValidDragPosition(
//     position: Position,
//     boardState: BoardState
//   ): boolean {
//     if (!this.onBoard(boardState.board, position)) {
//       return false;
//     }

//     return boardState.board[position.col][position.row].Pieces === null;
//   }
// }

// export default new EntangleHandler();
export {};
